<template>
	<div class="login">
		<!-- 登录页 -->

		<!-- 头部 -->
		<el-row class="login-header">
			<div class="logoImg"></div>
			<!--
			<span>logo图片</span>|舆情监测预警系统 -->
		</el-row>
		<!-- 中间-->
		<el-row class="content">
			<Verify :mode="'pop'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }" ref="verify" @success="onSuccess"></Verify>

			<div class="loginForm login-form">
				<el-row class="rowM"><img src="../assets/img/login/denglu-top.png" alt="" /></el-row>
				<el-row class="rowM fromBlock">
					<el-form ref="form" :model="form" :rules="rules">
						<el-form-item prop="username">
							<el-input v-model.trim="form.username" ref="username" placeholder="请输入用户名" @focus="focusfns('username')"  @keyup.enter.native="doLogin">
								<i slot="prefix" class="el-input__icon el-icon-user"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model.trim="form.password" ref="password" placeholder="请输入密码" show-password @focus="focusfns('password')" @keyup.enter.native="doLogin">
								<i slot="prefix" class="el-input__icon el-icon-lock"></i>
							</el-input>
						</el-form-item>
						<!-- <el-form-item>
							<slide-verification ref="slideVerification" :code-box="loginCodeBox"></slide-verification>
						</el-form-item> -->
					</el-form>
				</el-row>
				<el-row class="fromBlock fromBlock2">
					<div class="yz captcha-line" style="margin-bottom: 5px;" :class="{ mobilecode: !isNoCaptcha }">
						<el-input
							type="text"
							class="identify-text"
							ref="captcha"
							v-model="mobilecode"
							autocomplete="off"
							placeholder="验证码"
							maxlength="6"
							@input="resetNum('mobilecode')"
							@keyup.enter.native="doLogin"
						/>
						<el-button type="primary" class="btn" v-if="isNoCaptcha" @click="getCaptcha">获取验证码</el-button>
						<el-button type="primary" class="btn" v-else>{{ remainTime }}秒</el-button>
					</div>
				</el-row>
				<!-- <div class="info-text">
				 <div class="captcha-text">
				   验证码已达到上限，请24小时后再试
				
				 </div>
				  <div class="captcha-text">
				    验证码已发送至159****9583
				    <a class="showNum" style="cursor: pointer;" @click="changeMobile">更换手机号</a>
				  </div>
				  <div class="captcha-text2">
				    如需更换手机号,请联系客服
				    <span class="phone-num">17308491715</span>
				    <span class="arrow2"></span>
				  </div>
				</div> -->

				<div class="info-text">
					<div class="captcha-text" v-show="showText">
						{{ msg }}
						<a class="showNum" v-if="isShowNum" style="cursor: pointer;" @click="changeMobile">更换手机号</a>
					</div>
					<div class="captcha-text2" v-show="showText2">
						如需更换手机号,请联系客服
						<span class="phone-num">17308491715</span>
						<span class="arrow2"></span>
					</div>
				</div>
				<el-row class="paddingRL24">
					<el-col class="textL actionsCol">
						<!--  -->
						<span @click="apply" class="curpointer hovertext">申请试用</span>
						<span class="m20">|</span>
						<span @click="rePassword" class="curpointer hovertext">找回密码</span>
					</el-col>
				</el-row>
				<el-row class="paddingRL24">
					<el-button v-if="!form.onLogin" type="primary" @click="doLogin" class="login-btn btn-icon-flex">
						<!-- <img src="../assets/img/login/denglu-btn.png" alt="" > -->
						<i class="iconfont icondenglu btn-icon"></i>
						<span>登 录</span>
					</el-button>
					<el-button v-else type="primary" class="login-btn" style="height: 47px" :loading="true">登 录 中 ...</el-button>
				</el-row>
			</div>
		</el-row>
		<!-- 底部-->
		<el-row class="footer">
			<el-col :span="8">
				<div class="iconBlock">
					<div>
						<!-- <img src="../assets/img/login/botm-icon1.png" alt=""> -->
						<i class="iconfont iconshangwuhezuo1" style="font-size: 50px;color:#fff;"></i>
					</div>
					<div class="mLl0">
						<p>商务合作</p>
						<p>0731-85566167</p>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="iconBlock">
					<div>
						<!-- <img src="../assets/img/login/botm-icon2.png" alt=""> -->
						<i class="iconfont iconjishuzhichi1" style="font-size: 50px;color:#fff;"></i>
					</div>
					<div class="mLl0">
						<p>技术支持</p>
						<p>17308491715</p>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="iconBlock">
					<div>
						<!-- <img src="../assets/img/login/botm-icon3.png" alt=""> -->
						<i class="iconfont icondizhi2" style="font-size: 50px;color:#fff;"></i>
					</div>
					<div class="mLl0">
						<p>公司地址</p>
						<p>湖南省长沙市开福区马栏山创智园7栋</p>
					</div>
				</div>
			</el-col>
		</el-row>
		<!-- 找回密码 -->
		<re-password ref="rePassword" @success="successProp" @error="errorProp"></re-password>
		<!-- 申请试用 -->
		<apply ref="apply" @success="applySuccess"></apply>
		<!-- 申请成功 -->
		<apply-success ref="applySuccess"></apply-success>
		<!-- 成功得 弹框 -->
		<success-prop ref="successProp" :tips="tips"></success-prop>
		<!-- 首次登录 -->
		<first-sign ref="firstSign" :userInfo="userInfo" @success="firstSignSuccess"></first-sign>
		<closed-prop ref="closedprop" :tips="tips"></closed-prop>
		<overdue-prompt ref="overduePrompt" @loginOut="loginOut"></overdue-prompt>
	</div>
</template>

<script>
import RePassword from '@/views/components/login/rePassword.vue';
import SlideVerification from '@/components/SlideVerification.vue';
import Apply from '@/views/components/login/apply.vue';
import ApplySuccess from '@/views/components/login/ApplySuccess.vue';
import Verify from '@/components/verifition/Verify';
import SuccessProp from '@/components/promptbox/SuccessProp';
import ClosedProp from '@/components/promptbox/ClosedProp';
import FirstSign from '@/views/components/login/FirstSign.vue';
import OverduePrompt from '@/views/components/main/OverduePrompt.vue';

import loginApi from '@/api/login';

export default {
	name: 'Login',
	components: {
		RePassword,
		SlideVerification,
		Apply,
		ApplySuccess,
		Verify,
		SuccessProp,
		FirstSign,
		ClosedProp,
		OverduePrompt
	},
	data() {
		return {
			userInfo: {},
			form: {
				username: '',
				password: '',
				onLogin: false
			},
			rules: {
				username: [{ required: true, message: '请输入用户名', trigger: ' ' }],
				password: [{ required: true, message: '请输入密码', trigger: ' ' }]
			},
			loginCodeBox: 'loginCodeBox',
			verifyData: {
				success: false,
				captcha: ''
			},
			isFirst: false,
			tips: '',
			mobilecode: '', //短信验证码
			isNoCaptcha: true, //是否没有获取验证码
			remainTime: 120, //下一次获取验证码剩下的秒数
			mobile: '', // 发送验证码的手机号
			timer: null,
			showText: false, //是否显示下方文字
			msg: '', //文字内容
			isShowNum: false, //是否显示更改手机号吗
			showText2: false, //是否显示下方文字2
			msg2: '', //文字内容
			showTextTime: null
		};
	},
	created() {
		sessionStorage.clear();
		this.initPage();
	},
	beforeDestroy() {
		clearInterval(this.timer);
		clearTimeout(this.showTextTime);
	},
	methods: {
		showVerify() {
			this.$refs.verify.show();
		},
		onSuccess(event) {
			this.verifyData.success = true;
			this.verifyData.captcha = event.captchaVerification;
		},
		login: function() {
			let that = this;

			if (!that.verifyData.success) {
				this.$message.info('请先完成安全验证！');
				return;
			}
			that.$refs['form'].validate(valid => {
				if (!valid) {
					return false;
				}
				that.form.onLogin = true;
				loginApi
					.login({
						username: that.form.username,
						password: that.form.password,
						captcha: that.verifyData.captcha
					})
					.then(res => {
						that.form.onLogin = false;
						that.loginError();
						switch (res.returnCode) {
							case '1001':
								that.loginSuccess();
								break;
							case '3001':
								that.$message.error(res.returnMsg);
								// if(!res.returnData || res.returnData == {} ){
								//
								// }
								if (res.returnData.isFirstLogin == 1) {
									that.userInfo = res.returnData;
									that.$refs.firstSign.dialogVisible = true;
								}
								break;
							case '4002':
								that.rePassword();
								that.$message.error(res.returnMsg);

								break;
							default:
								that.$message.error(res.returnMsg);
						}
						//
					});
			});
		},
		loginSuccess() {
			let that = this;
			loginApi.getUserInfo().then(userInfo => {
				// debugger
				// console.log(userInfo);
				// console.log(userInfo.returnData);
				if(userInfo.returnCode != 1001) return that.$message.error(userInfo.returnMsg);
				that.$cookies.set('userInfo', userInfo.returnData, 30 * 60 * 60);
				// that.$cookies.set('userInfo2', JSON.stringify(userInfo.returnData), 30 * 60 * 60);
				that.$cookies.set('isLogin', true, 30 * 60 * 60);

				if (userInfo.returnData && userInfo.returnData.readOnly === 1) {
					//只读
					// console.log(userInfo.returnData.readOnly);
					this.$store.commit('setIsReadonly', true);
				} else {
					// this.$showBlock = true
					//非只读
					this.$store.commit('setIsReadonly', false);
				}
				let dueDate = userInfo.returnData.custInfo.dueDate;
				let currentdate = new Date();
				if (new Date(dueDate).getTime() < currentdate.getTime()) {
					that.$refs.overduePrompt.show();
				} else {
					that.pushRouter();
				}
			});
		},
		loginError: function() {
			this.verifyData.success = false;
			this.verifyData.captcha = '';
		},
		loginOut: function() {
			loginApi.logout().then(res => {
				this.$cookies.remove('userInfo');
				this.$cookies.remove('isLogin');
				this.$showBlock = true;
			});
		},
		rePassword: function() {
			/* dialogVisible */

			this.$refs.rePassword.dialogVisible = true;
		},
		apply: function() {
			this.$refs.apply.dialogVisible = true;
		},
		initPage() {
			let className = localStorage.getItem('app');
			if (!className) {
				document.getElementsByTagName('body')[0].className = 'theme' + 1;
				//document.getElementById('app').className = 'theme' + 1;
			} else {
				document.getElementsByTagName('body')[0].className = className;
				//document.getElementById('app').className = className;
			}
		},
		applySuccess() {
			this.$refs.applySuccess.dialogVisible = true;
		},
		successProp(obj) {
			this.tips = obj.tips;
			this.$refs.successProp.dialogVisible = true;
		},
		errorProp(obj) {
			this.tips = obj.tips;
			this.$refs.closedprop.dialogVisible = true;
		},
		//是否是首次登录
		isFirstSign() {
			// 调取接口 判断是否第一次登录 并赋值给isFirst
			// this.isFirst
			//不是首次登录
		},
		//首次登录确认
		firstSignSuccess() {
			// this.$router.push('/home/home')
			this.loginSuccess();
		},
		//输入框获得焦点后 清除错误提示
		focusfns(rulesname) {
			this.$refs['form'].clearValidate(rulesname);
		},
		pushRouter() {
			this.$router.push('/home/home');
			let className = localStorage.getItem('app');
			if (!className) {
				document.getElementsByTagName('body')[0].className = 'theme' + 1;
				//document.getElementById('app').className = 'theme' + 1;
			} else {
				document.getElementsByTagName('body')[0].className = className;
				//	document.getElementById('app').className = className;
			}
		},
		getCaptcha: function() {
			//去掉在账号密码输入框回车 登录的功能
			//1.验证账号密码 是否必填
			if (!this.verification()) return;
			this.getCaptchaNext();
			// this.$refs['form'].validate(valid => {
			// 	if (!valid) {
			// 		return false;
			// 	} else {
			// 		//2.账号密码加密后 发送请求给后端
			// 		this.getCaptchaNext();
			// 	}
			// });
		},
		verification: function() {
			this.isShowNum = false;
			let flag = false;
			if (this.form.username.length == 0) {
				this.$refs.username.focus();
				this.showText = true;
				this.msg = '请输入用户名';
				return flag;
			}
			if (this.form.password.length == 0) {
				this.$refs.password.focus();
				this.showText = true;
				this.msg = '请输入密码';
				return flag;
			}
			// this.showText = false;
			// this.msg = '';
			flag = true;
			return flag;
		},
		getCaptchaNext: async function() {
			let password = this.$encrypt(this.form.password);
			let username = this.$encrypt(this.form.username);
			let query = {
				username: username,
				password: password
			};
			let res = await loginApi.send(query);
			// if (res.returnCode !== '1001') return this.$message.error(res.returnMsg);
			if (res.returnCode !== '1001') {
				// this.$Message.error(res.returnMsg);
				this.showText = true;
				this.msg = res.returnMsg;
				return;
			}
			if (res.returnData.type === '1') {
				this.isNoCaptcha = false;
				this.showText = true;
				//首次
				this.isShowNum = true;
				this.msg = `验证码已发送至${res.returnData.mobile}`;
				//4.进入倒计时
				this.countDown();
			} else if (res.returnData.type === '2') {
				this.isNoCaptcha = false;
				this.showText = true;
				this.isShowNum = true;
				//120秒内提交
				//赋值

				var date1 = new Date(res.returnData.sendTime);
				var date2 = new Date(res.returnData.thisTime);
				var date3 = (date2.getTime() - date1.getTime()) / 1000; //相差秒数
				//3.返回的 剩余时间
				this.remainTime = 120 - date3;
				this.msg = `验证码已发送至${res.returnData.mobile}`;
				//4.进入倒计时
				this.countDown();
			} else if (res.returnData.type === '3') {
				this.showText = true;
				//短信验证码已达到上限，请24小时之后再试
				this.msg = '验证码已达到上限，请24小时后再试';
			}
		},
		countDown: function() {
			let that = this;
			that.timer = setInterval(() => {
				if (that.remainTime === 0) {
					that.remainTime = 120;
					clearInterval(this.timer);
					that.isNoCaptcha = true;
					this.showText = false;
					this.isShowNum = false;
				} else {
					that.remainTime--;
				}
			}, 1000);
		},
		resetNum: function($event) {
			// console.log($event);
			// console.log(this[$event]);
			let str = this[$event];
			this[$event] = str.replace(/[^\d.]/g, '');
		},
		changeMobile: function() {
			this.showText2 = true;
			clearTimeout(this.showTextTime);
			this.showTextTime = setTimeout(() => {
				this.showText2 = false;
			}, 3000);
		},
		doLogin: async function() {
			let that = this;
			if (!this.verification()) return;
			if (this.mobilecode.length == 0) {
				this.$refs.captcha.focus();
				this.showText = true;
				this.msg = '请输入验证码';
				return;
			}
			let query = {
				username: that.$encrypt(that.form.username),
				password: that.$encrypt(that.form.password),
				mobilecode: that.$encrypt(that.mobilecode)
			};
			that.form.onLogin = true;
			loginApi.signin(query).then(res => {
				that.form.onLogin = false;
				that.loginError();
				switch (res.returnCode) {
					case '1001':
						that.loginSuccess();
						break;
					// case '3001':
					// 	//that.$message.error(res.returnMsg);
					// 	this.showText = true;
					// 	this.msg = res.returnMsg;
					// 	if (res.returnData.isFirstLogin == 1) {
					// 		that.userInfo = res.returnData;
					// 		that.$refs.firstSign.dialogVisible = true;
					// 	}
					// 	break;
					case '4002':
						that.rePassword();
						//that.$message.error(res.returnMsg);
						this.showText = true;
						this.msg = res.returnMsg;
						break;
					default:
						// that.$message.error(res.returnMsg);
						this.showText = true;
						this.msg = res.returnMsg;
				}
				//
			});
		}
	},
	mounted() {
		// this.$refs.slideVerification.mountedFn()
		// this.$refs.firstSign.show()
	}
};
</script>

<style lang="less">
@import '../assets/css/page/login/login.less';
</style>
<style lang="less" scoped>
.login-form {
	.captcha-line {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 22px;
		&.mobilecode {
			margin-bottom: 10px;
		}
		.btn {
			background-color: #ff9b25;
			height: 40px;
			width: 190px;
			// padding: 0px 20px;
			color: #fff;
			border-color: #ff9b25;
			margin-left: 14px;
			padding: 0px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		/deep/.el-input {
			height: 40px;
			.el-input__inner {
				height: 40px;
			}
		}
	}
	.info-text {
		padding: 0px 24px;
		position: relative;
		box-sizing: border-box;
		.captcha-text {
			margin-top: 5px;
			margin-bottom: 10px;
			color: #ff9b25;
			// margin-bottom: 22px;
			text-align: center;
			// padding-left: 10px;
			font-size: 14px;
			line-height: 32px;
			background-color: #fff2e3;
			border-radius: 3px;
			// margin-bottom: 35px;
			.showNum {
				font-family: MicrosoftYaHei;
				font-size: 14px;
				color: #34a6e3;
			}
		}
		.captcha-text2 {
			margin-top: 5px;
			margin-bottom: 10px;
			width: calc(100% - 48px);
			text-align: center;
			line-height: 32px;
			background-color: #ffffff;
			border-radius: 3px;
			border: solid 1px #becfd9;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			color: #777777;
			position: absolute;
			margin-top: 8px;
			top: 32px;
			left: 50%;
			transform: translateX(-50%);
			white-space: nowrap;
			z-index: 80;
			.phone-num {
				color: #1ca7f1;
			}
			&::after {
				display: block;
				content: '';
				position: absolute;
				width: 0px;
				height: 0px;
				border: 8px solid transparent;
				border-bottom-color: #becfd9;
				top: -16px;
				right: 80px;
				z-index: 90;
			}
			.arrow2 {
				position: absolute;
				width: 0px;
				height: 0px;
				border: 8px solid transparent;
				border-bottom-color: #fff;
				top: -15px;
				right: 80px;
				z-index: 100;
			}
		}
	}
	.showNum {
		cursor: pointer;
	}
}
.login .content .loginForm .fromBlock2 {
	margin-top: 0px;
}
</style>
